import SectionEditor from '../components/SectionEditor';

export default function ContactEditor(){
  const fields = [
    { key: 'mapEmbedUrl', label: 'Google Maps Embed URL', type: 'text', help: 'Komplette https://www.google.com/maps/embed?... URL' },
  ];
  const defaults = {
    mapEmbedUrl: '',
  };
  return <SectionEditor sectionKey="contact" title="Kontakt / Karte" fields={fields} defaults={defaults} />;
}
